// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import resetStyles from "../styles/reset.module.scss"
import classNames from "classnames"
import React from "react"
import { NodeWithChildren } from "../helpers/node-with-children"
import styles from "./link.module.scss"
import { PrimitiveBaseProps, PrimitiveWithChildrenProps, PrimitiveWithSizing } from "../helpers/types"

interface Props
  extends React.AnchorHTMLAttributes<HTMLAnchorElement>,
    PrimitiveBaseProps<HTMLAnchorElement>,
    PrimitiveWithSizing,
    PrimitiveWithChildrenProps {}

export function Link(props: Props) {
  const {
    className,
    innerRef,
    "data-node-id": dataNodeId,
    direction,
    spacing,
    alignment = "start",
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props
  return (
    <NodeWithChildren
      direction={direction}
      spacing={spacing}
      alignment={alignment}
      mainAxisSizing={mainAxisSizing}
      crossAxisSpacing={crossAxisSizing}
    >
      {(nodeWithChildrenClassName) => (
        <a
          {...otherProps}
          className={classNames(resetStyles.reset, className, styles.root, nodeWithChildrenClassName)}
          ref={innerRef}
          data-node-id={dataNodeId}
        />
      )}
    </NodeWithChildren>
  )
}
